/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * ITenFrame.ts - Interfaces for all Ten Frames
*/


export function calculateHorizontalTenFrameSize(numFrames: number, usableWidth: number, usableHeight: number){

  const TEN_FRAME_MARGIN = 0.04;  
  const NUMBER_ELEMENTS_WIDTH = 5;
  const NUMBER_ELEMENTS_HEIGHT = numFrames * 2;

  // A ten frame consists of two rows of 5 counters to 
  // represent a number between 0 and 10
  // Each frame will have a 4% margin. Calculate the total space taken up by margins
  const totalFrameMarginHeight = usableHeight * numFrames * 2 * TEN_FRAME_MARGIN;
  const totalFrameMarginWidth = usableWidth * 2 * TEN_FRAME_MARGIN;

  // Calculate the size of the array element by finding the smallest
  // ratio between screen width and number of columns or screen height and number of rows.
  const elementHeight = Math.floor( (usableHeight-totalFrameMarginHeight) / NUMBER_ELEMENTS_HEIGHT);
  const elementWidth = Math.floor( (usableWidth-totalFrameMarginWidth) / NUMBER_ELEMENTS_WIDTH);
  const elementSize = Math.min(elementHeight, elementWidth);
  
  // Calculate internal margins
  const elementMargin = Math.floor(elementSize*0.05);
  const usableElementSize = elementSize - (2*elementMargin);

  return {usableElementSize, elementMargin};

}

export function calculateVerticalTenFrameSize(numFrames: number, usableWidth: number, usableHeight: number){

  const TEN_FRAME_MARGIN = 0.04;  
  const NUMBER_ELEMENTS_WIDTH = numFrames * 2;
  const NUMBER_ELEMENTS_HEIGHT = 5;

  // A ten frame consists of two rows of 5 counters to 
  // represent a number between 0 and 10
  // Each frame will have a 4% margin. Calculate the total space taken up by margins
  const totalFrameMarginHeight = usableHeight * 2 * TEN_FRAME_MARGIN;
  const totalFrameMarginWidth = usableWidth * 2 * numFrames * TEN_FRAME_MARGIN;

  // Calculate the size of the array element by finding the smallest
  // ratio between screen width and number of columns or screen height and number of rows.
  const elementHeight = Math.floor( (usableHeight-totalFrameMarginHeight) / NUMBER_ELEMENTS_HEIGHT);
  const elementWidth = Math.floor( (usableWidth-totalFrameMarginWidth) / NUMBER_ELEMENTS_WIDTH);
  const elementSize = Math.min(elementHeight, elementWidth);
  
  // Calculate internal margins
  const elementMargin = Math.floor(elementSize*0.05);
  const usableElementSize = elementSize - (2*elementMargin);

  return {usableElementSize, elementMargin};

}